export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-primary-600 via-primary-500 to-accent-500 p-8 md:p-14">
          <div className="absolute top-0 right-0 w-64 h-64 bg-background-50/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-background-50/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2"></div>

          <div className="relative flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            <div className="flex-1 text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 text-background-50 text-sm font-medium mb-6 whitespace-nowrap">
                <i className="ri-smartphone-line"></i>
                <span>移动端体验更佳</span>
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-4">下载91影视看片APP</h2>
              <p className="text-sm md:text-base text-background-50/85 leading-relaxed mb-8 max-w-md mx-auto lg:mx-0">
                随时随地高清追剧，支持离线缓存、个性化推荐与多端同步。打开APP，开启属于你的免费追剧之旅。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#app"
                  className="whitespace-nowrap w-full sm:w-auto px-6 py-3 rounded-xl bg-background-50 text-primary-600 font-semibold text-sm hover:bg-background-100 transition-colors flex items-center justify-center gap-2 cursor-pointer"
                  onClick={(e) => e.preventDefault()}
                >
                  <i className="ri-android-line text-lg"></i>
                  Android 下载
                </a>
                <a
                  href="#app"
                  className="whitespace-nowrap w-full sm:w-auto px-6 py-3 rounded-xl bg-background-50/20 text-background-50 font-semibold text-sm border border-background-50/30 hover:bg-background-50/30 transition-colors flex items-center justify-center gap-2 cursor-pointer"
                  onClick={(e) => e.preventDefault()}
                >
                  <i className="ri-apple-line text-lg"></i>
                  iOS 下载
                </a>
              </div>
            </div>

            <div className="flex-shrink-0">
              <div className="relative w-48 h-72 md:w-56 md:h-80 rounded-2xl bg-background-50/15 border border-background-50/20 overflow-hidden backdrop-blur-sm">
                <div className="p-3">
                  <div className="w-full aspect-[9/16] rounded-xl bg-background-200/30 flex items-center justify-center">
                    <i className="ri-movie-2-line text-4xl text-background-50/50"></i>
                  </div>
                  <div className="mt-3 space-y-2">
                    <div className="h-2 w-3/4 rounded-full bg-background-50/20"></div>
                    <div className="h-2 w-1/2 rounded-full bg-background-50/15"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}